import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';

import { Button } from '../../ui/button/button';

@Component({
  selector: 'app-organization-verification-modal',
  imports: [Button, MatIconModule, TranslocoDirective],
  templateUrl: './organization-verification-modal.html',
  styleUrl: './organization-verification-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationVerificationModal {
  private readonly dialogRef = inject(MatDialogRef<OrganizationVerificationModal>);

  protected close(): void {
    this.dialogRef.close();
  }
}
